import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions';

function ChatModal({
  message,
  show,
  systemMessages,
  onClose
}) {
  const modalClassName = classNames('cu-ui-chat-modal', {
    'is-shown': show,
  });

  return (
    <div className={modalClassName}>
      <div className='cu-ui-chat-modal__inner'>
        <div className='cu-ui-chat-modal__dialog'>
          <div className='cu-ui-chat-modal__dialog__content'>
            { message }
          </div>
          <div className="cu-ui-chat-modal__dialog__footer">
            <button className='cu-ui-chat-modal__dialog__button'
              onClick={onClose}
            >
              { systemMessages.close }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  show: state.chatRoot.isModalDialogOpen,
  message: state.chatRoot.modalDialogMessage,
  systemMessages: state.chatRoot.systemMessages
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: bindActionCreators(actions.closeModalDialog, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatModal);
